export default __webpack_public_path__ + "static/media/logo01.1a1ceb3c.png";